module.exports = __webpack_public_path__ + "static/media/risk2.7b3d1f91.png";